import { BusinessSearch } from "@/components/BusinessSearch";
import { Building2 } from "lucide-react";

export default function AdminBusiness() {
  return (
    <div data-testid="admin-business">
      <div className="flex items-center gap-3 mb-2">
        <span className="grid place-items-center w-10 h-10 bg-primary text-primary-foreground"><Building2 size={20} /></span>
        <h1 className="font-serif text-3xl tracking-tight">Business Lookup</h1>
      </div>
      <p className="text-muted-foreground mb-8 max-w-2xl text-sm">
        Search official Secretary of State records across all 50 states (powered by Cobalt Intelligence). Look up any entity by name to see its status, registered agent, SOS ID and address.
      </p>
      <div className="bg-background border-2 border-black/10 p-6">
        <BusinessSearch defaultState="NC" />
      </div>
    </div>
  );
}
